import { Box, Button, TextField } from '@mui/material'
import { makeStyles } from "@mui/styles";
import React, { useContext, useState } from 'react'
import { AuctionContext } from '../context/auctionContext'
import { getAuctionSocket } from '../services/socketAuction'

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  settingsButton: {
    border: `3px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    fontFamily: 'ITC Officina Sans Std, Bold',
    fontWeight: 'bold',
    fontSize: 16,
    width: 180,
  },
}))
export default function UploadButton() {
  const classes = useStyles()
  const { auction } = useContext(AuctionContext)
  const [promoVideoUrl, setPromoVideoUrl] = useState(auction.promoVideo)

  const onChangeHandler = (event) => {
    getAuctionSocket().emit('setPromoVideo', {
      auctionId: auction.id,
      url: promoVideoUrl,
    })
  }

  return (
    <Box className={classes.container} mb={1}>
      <TextField
        style={{ flex: 1 }}
        id="standard-basic"
        label="Video Promocional"
        variant="standard"
        value={promoVideoUrl}
        onChange={(e) => setPromoVideoUrl(e.target.value)}
      />
      <Button
        onClick={onChangeHandler}
        className={classes.settingsButton}
        component="label"
      >
        Cambiar Video
      </Button>
    </Box>
  )
}
